<template>
  <div class="contentHome">
    <div class="centerPage">
      <div class="left">
        <span class="title">服务类型</span>
        <div class="type">
          <p v-for="(obj,index) in serviceTypes" :key="obj.id" :class="active==index?'activeClass':''"
             @click="change(index)">
            <span>{{ obj.cnName }}</span>
            <img src="../../assets/img/activeImg.png" alt="" width="17" v-show="active==index">
          </p>
        </div>
      </div>
      <div class="right">
        <div class="flex symptom">
          <div v-if="serviceTypes[active].thumbnailPath" class="img "
               :style="'backgroundImage: url('+serviceTypes[active].thumbnailPath+')'"></div>
          <div class="desc">
            <h3>{{ serviceTypes[active].cnName }}</h3>
            <p class="ban-cp">{{ serviceTypes[active].briefDesc }}</p>
          </div>
        </div>

        <div v-if="doctors.length>0">
          <p class="classTitle">推荐医师</p>
          <div class="recommendPhysician flex">
            <div class="physcian flex" style="cursor: pointer" v-for="(item,ind) in doctors " :key="ind"
                 @click="toDoctorHomePage(item.account)">
              <div class="img " :style="'backgroundImage: url('+item.headImgPath+')'"></div>
              <div class="expertise">
                <strong>{{ item.fullName }}</strong>
                <p v-if="item.indications.length>0">
                  <span>咨询专长：</span>
                  <span class="overFlow">{{ item.indications|getServiceTypes(that) }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="exams.length>0">
          <p class="classTitle">推荐心理测试</p>
          <div>
            <div class="list" v-for="(item,index) in exams" :key="index" @click="toDetail(item.id)">
              <div :style="item.exhibitImg?'backgroundImage: url('+item.exhibitImg+')':''" class="listImg"></div>
              <div class="listRight">
                <h4>{{ item.title }}</h4>
                <p>{{ item.subTitle }}</p>
                <div class="date">
                  <span>￥<span>{{ item.price }}</span></span>
                  <span>{{ item.testedCount }}人已测</span>
                  <span>{{ item.msgCount }}人评论</span>
                  <span>{{ item.exceptTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="serviceTypes[active] && serviceTypes[active].remedies">
          <p class="classTitle">推荐治疗方法</p>
          <div class="way ban-cp" v-show="serviceTypes[active].remedies"
               style="white-space: pre-line;min-height: 150px;">
            {{ serviceTypes[active].remedies }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "serviceType",
  data() {
    return {
      that: this,
      active: 0,
      serviceTypes: [{}],
      doctors: [],
      exams: [],
      serviceTypeMap: new Map(),
    }
  },
  mounted() {

    document.onmousedown = function (e) {
      if (e.button == 2) {
        e.returnValue = false;
      }
    };

    document.addEventListener("copy", function (e) {
      //取消默认事件，才能修改复制的值
      e.preventDefault();
      //复制的内容
      let copyTxt = `${window.location.href}`;
      if (e.clipboardData) {
        e.clipboardData.setData('text/plain', copyTxt);
      } else if (window.clipboardData) {
        return window.clipboardData.setData("text", copyTxt);
      }
    });


    let defaultTypeId = base.utils.getQueryString("id");

    this.active = 0;
    this.$ajax.get(base.api.indication.types.all).then((res) => {
      if (res.data.status === 'success') {
        // 1. 赋值
        this.serviceTypes = res.data.list;
        // 2. 赋值Map、跳转指定类型
        $(res.data.list).each((i, o) => {
          this.serviceTypeMap.set(o.id, o);
          if (defaultTypeId) {
            if (o.id === defaultTypeId) {
              this.active = i;
            }
          }
        });
        // 额外信息
        this.$nextTick(this.loadRecommend());
      }
    });
  },
  methods: {
    loadRecommend() {
      let curType = this.serviceTypes[this.active];
      if (curType) {
        let id = curType.id;
        this.$ajax.get(base.api.indication.types.recommend.doctors.replace("{id}", id)).then((res) => {
          if (res.data.status === 'success') {
            this.doctors = res.data.list;
          }
        });
        this.$ajax.get(base.api.indication.types.recommend.exams.replace("{id}", id)).then((res) => {
          if (res.data.status === 'success') {
            this.exams = res.data.list;
          }
        });
      }
    },

    change(index) {
      this.active = index;
      this.loadRecommend();
    },
    toDetail(id) {
      this.$router.push({name: 'examDetail', query: {back: '2', id: id}});
    },
    toDoctorHomePage(account) {
      this.$router.push({path: '/' + account})
    }
  },
  filters: {
    getServiceTypes(indications, that) {
      if (indications) {
        let skills = [];
        $(indications).each((i, o) => {
          let skill = that.serviceTypeMap.get(o.id);
          if (skill && skill.cnName) {
            skills.push(skill.cnName);
          }
        });
        return skills.join("、");
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/serviceType.scss";

.flex.symptom {
  align-items: unset;

  .img {
    margin-top: 10px;
  }
}

.centerPage {
  display: flex;

  .right {
    background-size: 40%;
    background: url("~@/assets/img/ysh_logo_transparent.png") no-repeat bottom/40%, #F6F8FF;
    padding: 0 20px;
  }
;
}

.ban-cp {
  moz-user-select: -moz-none;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

</style>
